module.exports = __webpack_public_path__ + "img/pick3.82d96647.jpg";